import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { ToastrService } from 'ngx-toastr';
import { error } from 'console';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import * as _ from 'underscore';

@Component({
  selector: 'app-vehicle-assign-modal',
  templateUrl: './vehicle-assign-modal.component.html',
  styleUrls: ['./vehicle-assign-modal.component.css']
})
export class VehicleAssignModalComponent implements OnInit {
  @Input() selectedDriver
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onVehicleAssigned = new EventEmitter<any>();

  isSelectedFleet = false;
  fleetsList: any = [];
  search:any;
  preFundingSources = {};
  filteredFleetList = [];
  fundingSources = [];
  selectedFundingSources = [];

  constructor(
    private fleetService: FleetService,
    private toastr: ToastrService,
    private driverService: DriversService,
    private corporateService: CorporateService
  ) { }

  ngOnInit() {
    this.getFundingSources();
  }

  getFundingSources() {
    this.corporateService
      .getCorporateUsers("active")
      .subscribe(data => {
        if (data) {
          this.preFundingSources = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getFleet();
      });
  }

  getFleet() {
    if (this.selectedDriver) {
      this.fleetsList.length = 0;

      if (this.selectedDriver.isFleet) {
        this.isSelectedFleet = true;
        this.getFleetList({ driver: this.selectedDriver._id, source: this.selectedDriver.source });
      } else {
        this.isSelectedFleet = false;
        this.getFleetList({ status: 'active', source: this.selectedDriver.source });
      }
    }
  }

  updateFleet(fleet) {
    const newFleet: any = {
      fleetId: fleet._id,
      isFleet: true,
      fleet: {
        los: fleet.los,
        spaceType: fleet.spaceType,
        driverCarNumber: fleet.driverCarNumber,
        setiDecall: fleet.setiDecall
      }
    };

    this.assignFleet(newFleet, this.selectedDriver._id);
  }

  clearFleet(fleet) {
    this.assignFleet(fleet._id, this.selectedDriver._id);
    this.closeModal();
  }

  assignFleet(fleetId, driverId) {
    this.driverService.assignFleet(fleetId, driverId)
      .subscribe((data) => {
        if (data) {
          if (data.fleet) {

            let fleet = this.fleetsList.find(fleet => fleet._id === data.fleet);
            this.toastr.success(`'${fleet.driverCarNumber}' vehicle assigned to driver '${this.selectedDriver.displayName}'`, 'Alert');
            this.onVehicleAssigned.emit({isFleet: data.isFleet,fleet});

          } else {
            this.selectedDriver.isFleet = data.isFleet;
            this.toastr.error(`Vehicle taken back from driver '${this.selectedDriver.displayName}'`, 'Alert');
            this.onVehicleAssigned.emit({isFleet: false,fleet:{}});
          }
          this.closeModal();

        }
      }, (err) => {
        sweetAlert("Error", err, "error", "OK");
      });
  }

  onSelectFundingSource() {
    this.filteredFleetList = this.fleetsList.filter(fleet => {
      let isFundingSourceExist = true;

      if (fleet.fundingSources && this.selectedFundingSources && this.selectedFundingSources.length) {
        for (let fundingSource of this.selectedFundingSources) {
          const isIncluded = fleet.fundingSources.includes(fundingSource);
          if (isIncluded) {
            isFundingSourceExist = true;
            break;
          } else {
            isFundingSourceExist = false;
            // break;
          }
        }
      }

      if (isFundingSourceExist) {
        return true;
      } else {
        return false;
      }
    }
    );
  }

  closeModal() {
    this.onCloseModal.emit()
  }

  getFleetList(payload) {
    this.fleetService.getFleetList(payload)
      .subscribe(
        (data) => {
          if (data) {
            this.fleetsList = data;
            this.filteredFleetList = data;
            for (let fleet of this.fleetsList) {
              if (fleet.fundingSources && fleet.fundingSources.length) {
                for (let fundingSource of fleet.fundingSources) {
                  if (fundingSource && this.preFundingSources[fundingSource]) {
                    this.fundingSources.push(this.preFundingSources[fundingSource]);
                  }
                }
              }
            }
            this.fundingSources = _.uniq(this.fundingSources, '_id').sort();
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }
}
